import React from "react";
import { Tag } from "primereact/tag";

export const allowedStatusTransitions = {
  0: [3, 1],
  1: [0, 3],
  2: [],
  3: []
};

export const statusOptions = [
  { label: "Confirmed", value: 0 },
  { label: "Waiting", value: 1 },
  { label: "Transfered", value: 2 },
  { label: "Cancelled", value: 3 },
];

export const normalizeWaitList = (value) => {
  const parsed = Number(value);
  return Number.isNaN(parsed) ? 0 : parsed;
};

export const isConfirmedLike = (waitList) => {
  const status = normalizeWaitList(waitList);
  return status === 0 || status === 2;
};

export const isWaiting = (waitList) => normalizeWaitList(waitList) === 1;

export const normalizeID = (value) => {
  if (value === null || value === undefined || value === "") {
    return null;
  }

  const parsed = Number(value);
  return Number.isNaN(parsed) ? null : parsed;
};

export const getUserStatus = (waitlist) => (
  <Tag
    {...[
      { value: "Confirmed", severity: "success" },
      { value: "Waiting", severity: "warning" },
      { value: "Transfered", severity: "info" },
      { value: "Cancelled", severity: "danger" }
    ][normalizeWaitList(waitlist)]}
  />
);
